module.exports = __webpack_public_path__ + "img/Frame 1093three.aaeb2782.png";